import { useSyncExternalStore } from "react";
import { safeLocalStorage } from "@helpers/storage";

const STORAGE_KEY = "kick-busy-closes-demo";
const ON_VALUE = "on";

const listeners = new Set<() => void>();

const notifyListeners = () => {
    listeners.forEach((listener) => listener());
};

const handleStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY || event.key === null) {
        notifyListeners();
    }
};

const subscribe = (listener: () => void) => {
    if (listeners.size === 0) {
        window.addEventListener("storage", handleStorage);
    }
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
            window.removeEventListener("storage", handleStorage);
        }
    };
};

const getIsStoredOn = () => safeLocalStorage.getItem(STORAGE_KEY) === ON_VALUE;

/** Stores the browser-wide busy closes demo switch and updates every reader, in this tab and others. */
export const setBusyClosesDemoStoredOn = (isOn: boolean) => {
    if (isOn) {
        safeLocalStorage.setItem(STORAGE_KEY, ON_VALUE);
    } else {
        safeLocalStorage.removeItem(STORAGE_KEY);
    }
    notifyListeners();
};

/** The stored switch alone, without the staff check; `useIsBusyClosesDemoOn` adds it. */
export const useIsBusyClosesDemoStoredOn = (): boolean =>
    useSyncExternalStore(subscribe, getIsStoredOn, () => false);
